import { ShopPageNavProps } from "@bluebottlecoffee/design-system/components";
import { collectionPage, shopPage } from "../link-builders";
import { ShopCollectionNavQueryResult } from "../sanity/collection-queries";
import { PageLink } from "../sanity/shared";

export function toShopPageNavItems({
  region,
  lang,
  navLinks,
  trackClickCollection,
}: {
  region: string;
  lang: string;
  navLinks: ShopCollectionNavQueryResult[];
  trackClickCollection?(display: string, slug: string, url: string): any;
}): Pick<ShopPageNavProps, "navItems">[] {
  function toNavItems(pages: PageLink[]) {
    return pages.map(({ name, slug }) => {
      const link = collectionPage({ region, lang, slug });

      return {
        link,
        display: name,
        onClick: () => trackClickCollection?.(name, slug, link),
      };
    });
  }

  return navLinks
    .filter(
      (links) =>
        links.shopCollections?.length > 0 &&
        links.shopCollections?.every((collection) => collection !== null),
    )
    .map(({ name, slug, shopCollections }) => {
      const link = shopPage({ region, lang, slug });
      const navItems = toNavItems(shopCollections);

      const allBubble = {
        link,
        display: `All ${name}`, // todo: i18n the word All
        onClick: () => trackClickCollection?.(name, slug, link),
      };

      navItems.unshift(allBubble);

      return {
        navItems,
      };
    });
}
